import { z } from "zod";
import { wishlistItem } from "../../wishlist/schemas/wishlistItem";

export const PASSWORD_REGEX =
  /^(?=.*[a-zåäöøæ])(?=.*[A-ZÅÄÖÆØ])(?=.*[0-9]).{8,}$/;
export const BIRTH_DATE_REGEX =
  /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12][0-9]|3[01])$/;
export const PHONE_NUMBER_REGEX = /^\+[1-9]\d{1,14}$/;

export const registrationInput = z.object({
  email: z.email("errorEmailInvalid"),
  firstName: z.string(),
  lastName: z.string(),
  password: z.string().regex(PASSWORD_REGEX, "errorPasswordTooWeak"),
  isCompany: z.boolean(),
  phoneNumber: z.string().regex(PHONE_NUMBER_REGEX, "errorPhoneNumberNotValid"),
  locale: z.string(),
  socialSecurityNumber: z.string().nullish(),
  companyName: z.string().nullish(),
  companyOrganizationalNumber: z.string().nullish(),
  birthDate: z
    .preprocess(
      (value: unknown) =>
        typeof value === "string" && value.trim() === "" ? undefined : value,
      z
        .string()
        .regex(BIRTH_DATE_REGEX, { error: "errorBirthDateInvalid" })
        .nullish(),
    )
    .nullish(),
  wishlistItems: z.array(wishlistItem).nullish(),
  street: z.string().nullish(),
  city: z.string().nullish(),
  zipCode: z.string().nullish(),
  acceptsEmail: z.boolean().nullish().default(true),
  acceptsSms: z.boolean().nullish().default(true),
});

export type RegistrationInput = z.infer<typeof registrationInput>;
